import classNames from 'classnames';
import PropTypes from 'prop-types';
// V3 Components
import Toggle from '/@/v3/components/forms/toggle';
import styles from './styles.module.css';

function ToggleGroup(props: typeof propTypes) {
    const {
        flexDirection = 'column',
        flexWrap = 'nowrap',
        boolean = false,
        type,
        options,
        value,
        max,
        onChange,
        small,
    } = props;

    const handleChange = (option) => {
        return (checked) => {
            if (boolean) onChange([option.value]);
            else {
                if (checked && !value.includes(option.value)) onChange([...value, option.value]);
                else if (!checked && value.includes(option.value)) onChange(value.filter((v) => v !== option.value));
            }
        };
    };

    return (
        <div
            className={classNames(max === 1 || boolean ? styles.twoColumns : styles.root, props.className)}
            style={{ 'flex-direction': `${flexDirection}`, 'flex-wrap': `${flexWrap}` }}
        >
            {options.map((option) => {
                const selected = value.includes(option.value);
                const disabled = !boolean && max !== undefined && !selected && value.length === max;
                return (
                    <Toggle
                        key={option.value}
                        type={type}
                        theme={props.theme}
                        label={option.label}
                        value={selected}
                        disabled={disabled}
                        onChange={handleChange(option)}
                        small={small ? true : false}
                    />
                );
            })}
        </div>
    );
}

const propTypes = {
    type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
    theme: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.any.isRequired,
        })
    ).isRequired,
    max: PropTypes.number,
    value: PropTypes.arrayOf(PropTypes.number).isRequired,
    onChange: PropTypes.func.isRequired,
    flexDirection: PropTypes.string,
    flexWrap: PropTypes.string,
    small: PropTypes.bool,
    boolean: PropTypes.bool,
    className: PropTypes.string,
};
ToggleGroup.propTypes = propTypes;
export default ToggleGroup;
